import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import { BrowserRouter } from 'react-router-dom';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import './scss/styles.scss';
import CssBaseline from '@mui/material/CssBaseline';
import store from '../src/app/store';
import { ThemeProvider } from '@mui/material/styles';
import { ClerkProvider } from '@clerk/clerk-react';
import { themeBasic } from './app/common/theme/theme';

import './i18n/config';

import App from './app';
// Import your Publishable Key
const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || '';

const customLocalization = {
  signIn: {
    start: {
      subtitle: 'Welcome back! Please sign in to continue.',
    },
  },
};

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Publishable Key');
}

const root = createRoot(document.getElementById('root')!);

const ThemeAppBlock = () => {
  return (
    <ThemeProvider theme={themeBasic}>
      <ClerkProvider
        publishableKey={PUBLISHABLE_KEY}
        afterSignOutUrl='/login'
        signInForceRedirectUrl={'/'}
        touchSession={false}
        localization={customLocalization}
        appearance={{
          variables: {
            colorPrimary: '#6414DB',
          },
        }}
      >
        <App />
      </ClerkProvider>
    </ThemeProvider>
  );
};

root.render(
  <StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <CssBaseline />
        <ThemeAppBlock />
        <ToastContainer
          position='top-right'
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme='light'
        />
      </BrowserRouter>
    </Provider>
  </StrictMode>
);
